import React, { Component } from 'react';
import Wrp from '../Wrp/Wrp';

class PageHeader extends Component {
    
    render () {
        return (
            <Wrp>
                <div className="page-header">
                    {this.props.children}
                </div>
            </Wrp>
        )
    }
}

export default PageHeader;